export default {
  currentUser: '',
  vacancy: undefined
};
